"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Callout = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var theme_1 = require("../theme");

exports.Callout = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0.5em 1em;\n  margin-top: 0.5em !important; // override node\n  margin-bottom: 1em !important; // override node\n  background: ", ";\n  border-radius: 4px;\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  ", "\n  small {\n    color: ", ";\n    font-weight: 700;\n  }\n\n  // TEXT ALIGNMENT\n  ", "\n\n  // VARIANTS\n  ", "\n"])), theme_1.theme.colors.brand[900], theme_1.theme.colors.brand[700], theme_1.theme.effects.shadow[300], function (p) {
  return typeof p.onClick === "function" ? "cursor: pointer;" : "";
}, theme_1.theme.colors.gray[700], function (props) {
  if (props.textAlign) return (0, styled_components_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        text-align: ", ";\n      "])), props.textAlign);
}, function (props) {
  // DEPRECATE styleType
  // @ts-ignore
  if (props.variant === "error" || props.styleType === "error") {
    return (0, styled_components_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background: ", ";\n        border-color: ", ";\n        box-shadow: none;\n        small {\n          color: ", ";\n\n          svg {\n            stroke: ", ";\n            width: 1em;\n            height: 1em;\n          }\n        }\n      "])), theme_1.theme.colors.red[900], theme_1.theme.colors.red[900], theme_1.theme.colors.red[500], theme_1.theme.colors.red[500]);
  } // DEPRECATE styleType
  // @ts-ignore


  if (props.variant === "warning" || props.styleType === "warning") {
    return (0, styled_components_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        background: ", ";\n        border-color: ", ";\n        box-shadow: none;\n        small {\n          color: ", ";\n\n          svg {\n            stroke: ", ";\n            width: 1em;\n            height: 1em;\n          }\n        }\n      "])), theme_1.theme.colors.yellow[900], theme_1.theme.colors.yellow[700], theme_1.theme.colors.gray[500], theme_1.theme.colors.yellow[700]);
  }
});